module.exports = __webpack_public_path__ + "static/media/loanVector.2f494471.jpg";